import React from 'react';

interface CustomDateInputProps {
  value: string;
  onClick?: () => void;
  placeholder?: string;
}

/**
 * Custom input component for DatePicker
 * Provides a styled, read-only input field for date selection
 */
export const CustomDateInput = React.forwardRef<HTMLInputElement, CustomDateInputProps>(
  ({ value, onClick, placeholder }, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder={placeholder}
      className="form-input date-picker-input"
      readOnly
    />
  )
);

CustomDateInput.displayName = 'CustomDateInput';
